import axios from "axios";

export const state = {
    reportdepartmentanalysis: [],
};

export const getters = {
    reportdepartmentanalysis: state => state.reportdepartmentanalysis,
};

export const mutations = {
    setReportDepartmentAnalysis(reportdepartmentanalysis, newValue) { state.reportdepartmentanalysis = newValue},
};

export const actions = {
    fetchReportDepartmentAnalysis({ commit }) {
        axios.get('/reportdepartmentanalysis').then(res => {
            commit('setReportDepartmentAnalysis', res.data.payments)
        })
    },
    filterReportDepartmentAnalysis({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportdepartmentanalysis";
        axios.post(url, formData).then((response) => {
            commit('setReportDepartmentAnalysis', response.data.payments)
        })
    },
};
